var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHorserace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    viewBox: "0 0 96 96",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m89.6 14.32-2.4 4.56h.04L96.04 35l-4.88 4.36L84.88 35c-2.24-.72-3.08-3.64-3.08-3.64L74.6 48.2c-3.32 10.72-5.16 12.08-7.28 13.44L54.24 77.56l-13.88-4.48 1.68-2.72 9.6 2.36 4.68-12.56c-12.24-1.32-23.16-7.56-23.16-7.56-2.28 6.08-5.84 9.84-7.88 11.88l9.72 9.4-7.04 7.8-3.76-2.2 3.12-5-13.2-10.28c6.28-4.24 6.6-10.12 6.6-10.12-5.76-1.52-8.72-9.24-8.72-9.24-7.96 3.8-12 14.44-12 14.44V45.52C17.24 28.88 26.08 28.4 26.08 28.4c7.099-.671 10.416.253 14.047 1.265 2.424.676 4.989 1.391 8.913 1.695 9.8.76 13.68-2.72 13.68-2.72 9.96-9.68 15.56-11.6 15.56-11.6zM74.158 70.04l-1.24-2.72c4.48-2.56 5.08-6.4 5.08-6.4l3.48 9.72-11.56 5.6-1.52-2.44z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHorserace);
export default __webpack_public_path__ + "static/media/horserace.2a96452678106eb0f89c16b1ad7f8bce.svg";
export { ForwardRef as ReactComponent };